// TravelRoutes.js
import React, { useEffect, useRef, useState } from "react";
import { FaExchangeAlt } from "react-icons/fa";

// 🇺🇸 **NEW US Domestic Routes**
const domesticRoutes = [
  { from: "LAX", to: "JFK", dateFrom: "11 Oct 2025", dateTo: "11 Oct 2025", price: "$158", img: "/assets/newy.jpeg" },
  { from: "ORD", to: "MIA", dateFrom: "28 Aug 2025", dateTo: "28 Aug 2025", price: "$142", img: "/assets/miami.jpg" },
  { from: "DFW", to: "LAS", dateFrom: "23 Nov 2025", dateTo: "23 Nov 2025", price: "$89", img: "/assets/vegas.jpg" },
  { from: "ATL", to: "LAX", dateFrom: "14 Sep 2025", dateTo: "14 Sep 2025", price: "$165", img: "/assets/losangeles.jpg" },
  { from: "SEA", to: "SFO", dateFrom: "17 Aug 2025", dateTo: "17 Aug 2025", price: "$129", img: "/assets/sfo.jpg" },
  { from: "BOS", to: "DCA", dateFrom: "21 Sep 2025", dateTo: "21 Sep 2025", price: "$98", img: "/assets/washington.jpg" }
];

// 🌍 **NEW International Routes (Departing USA)**
const internationalRoutes = [
  { from: "JFK", to: "LHR", dateFrom: "11 Oct 2025", dateTo: "11 Oct 2025", price: "$499", img: "/assets/london.jpg" },
  { from: "LAX", to: "NRT", dateFrom: "28 Aug 2025", dateTo: "28 Aug 2025", price: "$612", img: "/assets/tokyo.jpg" },
  { from: "ORD", to: "CDG", dateFrom: "23 Nov 2025", dateTo: "23 Nov 2025", price: "$535", img: "/assets/paris.jpg" },
  { from: "MIA", to: "GRU", dateFrom: "14 Sep 2025", dateTo: "14 Sep 2025", price: "$420", img: "/assets/brazil.jpg" },
  { from: "SFO", to: "SYD", dateFrom: "17 Aug 2025", dateTo: "17 Aug 2025", price: "$899", img: "/assets/sydney.jpg" },
  { from: "JFK", to: "DXB", dateFrom: "21 Sep 2025", dateTo: "21 Sep 2025", price: "$779", img: "/assets/dubai.jpg" }
];

const TravelRoutes = () => {
  const [tab, setTab] = useState("domestic");
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-up-visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    cardRefs.current.forEach((ref) => ref && observer.observe(ref));
  }, [tab]);

  const data = tab === "domestic" ? domesticRoutes : internationalRoutes;

  return (
    <section className="max-w-7xl mx-auto px-6 py-16">

      {/* Title */}
      <h2 className="text-3xl font-bold text-gray-900 text-center mb-6">
        Popular Routes
      </h2>

      {/* Tabs */}
      <div className="flex justify-center gap-4 mb-10">
        <button
          className={`px-6 py-2 rounded-full border text-sm font-semibold transition-all 
            ${tab === "domestic" ? "bg-orange-500 text-white shadow-lg" : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"}`}
          onClick={() => setTab("domestic")}
        >
          Domestic
        </button>

        <button
          className={`px-6 py-2 rounded-full border text-sm font-semibold transition-all 
            ${tab === "international" ? "bg-orange-500 text-white shadow-lg" : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"}`}
          onClick={() => setTab("international")}
        >
          International
        </button>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {data.map((route, index) => (
          <div
            key={index}
            ref={(el) => (cardRefs.current[index] = el)}
            className="
              opacity-0 translate-y-8 transition-all duration-[700ms] ease-out
              bg-white rounded-2xl shadow-md overflow-hidden cursor-pointer 
              hover:shadow-xl hover:-translate-y-1
            "
          >
            {/* Image */}
            <img src={route.img} className="h-44 w-full object-cover" alt="Route" />

            {/* Card Content */}
            <div className="p-5">
              <div className="flex items-center justify-center text-lg font-semibold text-gray-900">
                {route.from}
                <FaExchangeAlt className="mx-2 text-teal-600 text-xl" />
                {route.to}
              </div>

              <div className="flex justify-between text-sm text-gray-500 mt-3">
                <span>{route.dateFrom}</span>
                <span>{route.dateTo}</span>
              </div>

              <div className="flex justify-between items-center mt-3">
                <span className="text-teal-600 font-medium">Economy</span>
                <span className="font-bold text-gray-900">{route.price}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Fade Animation Style */}
      <style>{`
        .fade-up-visible {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>

    </section>
  );
};

export default TravelRoutes;
